import searchAndChooseView from './searchAndChooseComponent.html';
import './searchAndChooseComponent.css';
import _ from 'lodash';
import matchesAllWords, { splitIntoWords } from '../matchesAllWords/matchesAllWords.js';

export function searchAndChooseComponent() {
	return {
		bindings: {
			items: '<',
			onSelect: '&?',
			searchText: '=?',
			selectedItem: '=?',
			maxItemsWhenFiltered: '<?',
			maxItemsWhenEmpty: '<?',
			placeholderText: '<?',
			isDisplayed: '=?',
		},
		controllerAs: 'vm',
		controller: searchAndChooseComponentCtrl,
		template: searchAndChooseView,
	};
}

export class searchAndChooseComponentCtrl {
	constructor() {
		'ngInject';
		this.itemNavigation = this.itemNavigation.bind(this);
	}

	$onInit() {
		this.maxItemsWhenFiltered = this.maxItemsWhenFiltered || Infinity;
		this.maxItemsWhenEmpty = this.maxItemsWhenEmpty || Infinity;
		this.searchText = this.searchText || '';
		this.isDisplayed = this.isDisplayed || false;
		this.totalItemsShowing =
			this.items.length > this.maxItemsWhenFiltered ? this.maxItemsWhenFiltered : this.items.length;
		this.items.forEach(item => {
			item.searchLower = item.search.toLocaleLowerCase();
		});
		this.filter();
	}

	itemNavigation(evt) {
		switch (evt.keyCode) {
			case 38:
				// pressed ↑ arrow - If first item is highlighted, highlight final item. otherwise, highlight item above.
				this.navIdx = this.navIdx <= 0 ? this.totalItemsShowing - 1 : this.navIdx - 1;
				break;
			case 40:
				// pressed ↓ arrow - If last item is highlighted, highlight first item. otherwise, highlight item below.
				this.navIdx = this.navIdx === this.totalItemsShowing - 1 ? 0 : this.navIdx + 1;
				break;
			case 13:
				// pressed enter - select the current item
				if (this.navIdx >= 0) {
					this.isDisplayed = false;
					this.selectItem(this.displayedItems[this.navIdx]);
				}
				break;
			case 27:
				// pressed esc - close the dropdown
				this.isDisplayed = false;
				break;
			default:
				this.navIdx = -1;
		}
	}

	filter() {
		// reset selected idx so that when they press any key, no item is selected
		this.navIdx = -1;
		let shownCount = 0;
		const searchWords = splitIntoWords(this.searchText);
		if (this.searchText === '') {
			this.displayedItems = this.items.slice(0, this.maxItemsWhenEmpty);
			shownCount = this.displayedItems.length;
			if (this.selectedItem && _.findIndex(this.displayedItems, { id: this.selectedItem.id }) == -1) {
				this.displayedItems.unshift(this.selectedItem);
			}
		} else {
			this.displayedItems = [];
			this.items.some((item, i) => {
				if (shownCount >= this.maxItemsWhenFiltered) {
					return true;
				}
				if (matchesAllWords(item.searchLower, searchWords)) {
					// matches filter
					shownCount++;
					this.displayedItems.push(item);
				}
			});
		}
		this.totalItemsShowing = shownCount;
	}

	selectItem(item) {
		this.isDisplayed = false;
		this.selectedItem = item;
		this.onSelect && this.onSelect({ $item: item });
	}
}
